import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class FilterSortModalHandlerService {
    private activeModalSubject = new BehaviorSubject<string | null>(null);
    public activeModal$ = this.activeModalSubject.asObservable();

    setActiveModal(modalName: string) {
        this.activeModalSubject.next(modalName);
    }

    closeAllModals() {
        this.activeModalSubject.next(null);
    }

    canOpenModal(modalName: string): boolean {
        const currentModal = this.activeModalSubject.value;
        return currentModal === null || currentModal === modalName;
    }
}
